module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": _vm.classType,
      "dismissible": ""
    },
    on: {
      "dismissed": function($event) {
        return _vm.closeNotification()
      }
    }
  }, [(_vm.multiMessage) ? _c('ul', _vm._l((_vm.notification.message), function(item) {
    return _c('li', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0) : _c('span', [_vm._v("\n      " + _vm._s(_vm.notification.message) + "\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-782e39f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification.vue
// module id = 1332
// module chunks = 16